<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "FaqForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {},
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        renting_type_slug_options: this.$store.getters[
          config.storeNamespace + "/getTypes"
        ]
      };
    }
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item
          };
          this.isBusy = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Faq/FaqForm.vue